import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/services/Content";
import ModificationConttent from "../sections/services/ModificationContent";
import { useTranslation } from "react-i18next";

const Modification = () => {
  const {t} = useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Loan Modification</title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: t("Loan Modification") }} />
      <ModificationConttent />
      <Footer />
    </Fragment>
  );
};

export default Modification;
